const Herodata = {
  aboutUs: {
    title: "About Our Company",
    subtitle: "Trusted home service professionals with 10+ years of experience",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  acRepair: {
    title: "Expert AC Repair Services",
    subtitle: "Fast, reliable cooling solutions for all brands and models",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  washingMachinRepair: {
    title: "Washing Machine Repair",
    subtitle: "Same-day service to get your laundry back on track",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  RefrigeratorRepair: {
    title: "Refrigerator-Repair Services",
    subtitle: "Clean water solutions with certified technicians",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  MicrowaveOvenRepair: {
    title: "Microwave Oven Repair",
    subtitle: "Quick fixes to keep your kitchen running smoothly",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  whyChooseUs: {
    title: "Why Choose Our Services?",
    subtitle: "Quality repairs, honest pricing, and guaranteed satisfaction",
    backgroundImage: "src/assets/Images/img4.avif",
  },
  contact: {
    title: "Contact Our Team",
    subtitle: "24/7 availability for all your home appliance emergencies",
    backgroundImage: "src/assets/Images/img4.avif",
  },
};

export default Herodata;
